import * as React from "react";

function Plus(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 13 12" fill="none" {...props}>
      <path d="M6.542 11L6.417 1l.125 10z" fill="#772ED3" />
      <path
        d="M6.542 11L6.417 1M1.5 6.041l10-.083"
        stroke={props.color || "#fff"}
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Plus;
